export default __webpack_public_path__ + "static/media/trashCan.225abae6.svg";